export const SELECT_TEMPLATE = 'SELECT_TEMPLATE'
export const RESET_TEMPLATE = 'RESET_TEMPLATE'
